import merge from 'lodash/merge'
import baseStyles from '../Base/Base.styles'
import { parseResponsiveProperty } from '@converdy/styles'
import baseBackgroundStyles from '../BaseBackground/BaseBackground.styles'
import BaseDividersStyles from '../BaseDividers/BaseDividers.styles'

const contentAlignmentMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
}

export default ({
  base,
  height,
  maxHeight,
  width,
  maxWidth,
  contentAlignment,
  background,
  dividers,
  borderColor
}) => {

  let jss = {
    root: {
      ...baseStyles(base),
      // justifyContent: false, // Overwrite default alignment
      // '& .box > *': responsiveAlignment(base.alignment),  // Todo find a solution to align children discuss with Chris
      "& > .box": {
        borderColor,
        borderWidth: 'var(--themeBorderThickness)'
      }
  } }

  /*

  Todo: add overflow options 
  */

  if(height === 'custom') {

    merge(jss.root, {
      '& > .box': merge(   
        parseResponsiveProperty(v => {
          return v && v.value && v.unit ? {
            height: v.value + v.unit,
          } : {} 
        }, maxHeight),
        parseResponsiveProperty(v => {
          return {
            justifyContent: contentAlignmentMap[v],
          }
        }, contentAlignment))
      })
  } 

  if(width === 'custom') {

    merge(
      jss.root['& > .box'],
      parseResponsiveProperty(v => {
      return v && v.value && v.unit ? {
        maxWidth: v.value + v.unit,
      } : {} 
    }, maxWidth))

  } 
  
  if (background) {
    merge(jss.root, {
      '& > .box': baseBackgroundStyles(background)
    })
  }

  if(dividers) {
    merge(jss.root, {
      '& > .box': {
        ...BaseDividersStyles(dividers)
      }
    })

  }

  return jss
}